import { Col, Form, FormGroup, Input, Label, Row } from "reactstrap"
import DynamicButton from "../../../common/AdminCommonComponents/Buttons/DynamicButton/DynamicButton"
import LightGrayBgWrapper from "../../../common/AdminCommonComponents/LightGrayBgWrapper/LightGrayBgWrapper"
import GrayHeading from "../../../common/AdminCommonComponents/GrayHeading/GrayHeading"
import GeneralBackButton from "../../../common/AdminCommonComponents/Buttons/GeneralBackButton/GeneralBackButton"

const AddNewDeliveryZone = () => {

  return (
    <LightGrayBgWrapper>
      <div className="bg-white shadow px-4 p-3">
        <GeneralBackButton />
        <div className="d-flex justify-content-center">
          <GrayHeading>Add Delivery Zone</GrayHeading>
        </div>

        <Form className="mt-3" onSubmit={(e) => e.preventDefault()}>
          <Row className="row-cols-1 row-cols-md-2">
            <Col>
              <Row className="g-0">
                <Col md={12}>
                  <FormGroup>
                    <Label className="fw-medium" for="countryName">
                      Country Name
                    </Label>
                    <Input id="countryName" name="countryName" placeholder="" type="text" />
                  </FormGroup>
                </Col>
                <Col md={12}>
                  <FormGroup>
                    <Label className="fw-medium" for="availableMethods">
                      Available Methods
                    </Label>
                    <Input id="availableMethods" name="availableMethods" placeholder="" type="text" />
                  </FormGroup>
                </Col>
              </Row>
            </Col>
            <Col>
              <Row className="g-0">
                <Col xs="12">
                  <FormGroup>
                    <Label className="fw-medium" for="city">
                      City
                    </Label>
                    <Input id="city" name="city" placeholder="" type="text" />
                  </FormGroup>
                </Col>
                <Col xs="12">
                  <FormGroup>
                    <Label className="fw-medium" for="defaultRate">
                      Default Rate
                    </Label>
                    <Input id="defaultRate" name="defaultRate" placeholder="" type="text" />
                  </FormGroup>
                </Col>
              </Row>
            </Col>
          </Row>

          <div className="d-flex justify-content-end gap-3 my-3">
            <DynamicButton theme="blue-outline">Cancel</DynamicButton>
            <DynamicButton theme="blue">Save</DynamicButton>
          </div>
        </Form>
      </div>
    </LightGrayBgWrapper>
  )
}

export default AddNewDeliveryZone
